module.exports = __webpack_public_path__ + "img/embersadrift-screenshot-10.baf5d5a7.jpg";